// components/Typography.tsx
import { Typography as MuiTypography } from '@mui/material';

import { responsiveFontSizes } from './fontSizes';

import type { TypographyProps as MuiTypographyProps } from '@mui/material';

interface CustomTypographyProps extends Omit<MuiTypographyProps, 'size'> {
  size?: keyof typeof responsiveFontSizes; // 32, 24, etc.
}

const Typography = ({ size = 16, sx, ...rest }: CustomTypographyProps) => {
  return (
    <MuiTypography
      sx={{ fontSize: responsiveFontSizes[size], ...sx }}
      {...rest}
    />
  );
};

export default Typography;
